<template>
  <div style="padding: 10px;">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-10">
            <h4>Unidade Organizacional</h4>
        </div>
        <div class="col-md-2">
              <button class="btn btn-success" @click="cadastro()" style="margin-right: 5px; 
                  border-color: rgb(0, 150, 136); color: rgb(0, 150, 136);margin-top: 21px;float: right;margin-right: 22px;">Cadastrar</button>
        </div>
      </div>
    </div>
    <div class="col-md-12" v-if="sucessoDelete">
        <div class="card" style="background-color: rgb(50 170 159) !important;color: #fff !important;margin-bottom: 20px !important;" >
            <div class="card-body">
                <div class="row">
                  <div class="col-md-4" >
                      {{sucessoDelete}}
                  </div>
                </div>
            </div>  
        </div> 
    </div>
    <div class="col-md-12" >
      
      <vue-good-table 
        :columns="columns"
        :rows="departamento"
        :lineNumbers="false"
        :search-options="{
          enabled: true,
          placeholder: 'Pesquisar',
        }"
        :pagination-options="{
              enabled: true,
              mode: 'records',
              mode: 'pages',
              perPage: 5,
              position: 'bottom',
              perPageDropdown: [5, 10, 15],
              dropdownAllowAll: false,
              nextLabel: 'Próximo',
              prevLabel: 'Anterior',
              rowsPerPageLabel: 'Linhas por página',
              ofLabel: 'de',
              pageLabel: 'pagina', 
              allLabel: 'All',
        }"
        >
          <template slot="table-row" slot-scope="props">
              <!--<div v-if="props.column.field == 'exibir_ao_publico'">
                 <span v-if="props.row.status">
                     <switch-button v-model="props.row.exibir_ao_publico" color="#253DB9" :meuid="props.row.id" modulo="departamento" funcao="exibirPublico"></switch-button>
                  </span>
                  <span v-else>
                      <switch-button  color="#bdbdbd" disabled></switch-button>
                  </span>
              </div>-->
              
              <div v-if="props.column.field == 'status'">
                  <switch-button v-model="props.row.status" color="#253DB9" :meuid="props.row.id" modulo="departamento" funcao="exibirStatus" title="Ativo" v-if="props.row.status == true"></switch-button>
                  <switch-button v-model="props.row.status" color="#253DB9" :meuid="props.row.id" modulo="departamento" funcao="exibirStatus" title="Desativado" v-if="props.row.status == false"></switch-button>
              </div>

              <span v-if="props.column.field == 'action'">
                <button class="btn btn-primary" @click="editar(props.row)" style="margin-right:5px;"><i class="fa fa-pencil-square-o"></i></button>
                <button class="btn btn-danger" @click="delete_option(props.row.id)" v-if="props.row.id != 1"><i class="fa fa-times"></i></button>
              </span>

              <span v-else>
                <span v-if="props.column.field != 'exibir_ao_publico' && props.column.field != 'status'">
                   {{props.formattedRow[props.column.field]}}
                </span>   
              </span>

          </template>
      </vue-good-table> 
    </div>  
    
  </div>
  
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';
import axios from 'axios';
import store from "src/store.js"
import 'src/controller/sistema/assuntoSecretariaController.js'
import SwitchButton from 'src/components/switch.vue'

export default {
  name: 'unidade',
  components: {
    VueGoodTable,
    SwitchButton 
  },
  data(){
    return {
      columns: [
        {
          label: 'Unidade Organizacional',
          field: 'secretaria',
        },
        /*{
          label: 'Exibir ao publico',
          field: 'exibir_ao_publico',
        },*/
        {
          label: 'Status',
          field: 'status',
        },
        {
          label: 'Ações',
          field: 'action',
          sortable: false,
        },
        {
          label: 'id',
          field: 'id',
          hidden: true,
        }
        
      ],
      departamento:[],
      result_detalhes:null,
      sucessoDelete:null,
    };
  },
   methods: {
      editar(row){
        //console.log(row);
        this.$router.push({name: 'departamentoeditar',params:{row: row} } );
      },
      cadastro(){
        this.$router.push({name: 'departamentocadastro'} );
      },
      delete_option(id){
         if (confirm("Deseja excluir?")){
            this.Deletar(id);
         } 
      },
      async Deletar(id){
        try {
           await this.$deletarDepartamento(id);
           this.sucessoDelete = "Deletado com Sucesso!";
           this.departamento = [];
           this.listarTudo();
        }catch (e) {
          let msgAlterada = e.response.data.msg;
          alert(msgAlterada);
        } 
      },
      async listarTudo(){
        try {
           let s = await this.$secretariaAvan();
           let dep = s.data.reverse();
           //this.departamento = s.data;
           let exibir_publico = null;
           let status = null;

           dep.forEach(array => {
              if(array.exibir_ao_publico == 1){
                  exibir_publico= true;
                  if(array.status==1){
                      status = true;
                      let departament={
                          secretaria: array.secretaria,
                          exibir_ao_publico: exibir_publico, 
                          status: status,
                          id: array.id
                      };
                      this.departamento.push(departament);
                  }else{
                     status = false;
                     let departament={
                          secretaria: array.secretaria,
                          exibir_ao_publico: exibir_publico, 
                          status: status,
                          id: array.id
                     };
                     this.departamento.push(departament);
                  }
                  
              }else{
                  exibir_publico = false;
                  if(array.status==1){
                    status = true;
                    let departament={
                        secretaria: array.secretaria,
                        exibir_ao_publico: exibir_publico, 
                        status: status,
                        id: array.id
                    };
                    this.departamento.push(departament);
                  }else{
                     status = false;
                     let departament={
                          secretaria: array.secretaria,
                          exibir_ao_publico: exibir_publico, 
                          status: status,
                          id: array.id
                     };
                     this.departamento.push(departament);
                  }
                 
              }
           });
           // this.departamento.push(departament); 
            
        } catch (e) {
              
        }
      }

  },
  beforeMount() {
    try {
      this.listarTudo();
    }catch(e){
      
    }    
    
  }
};
</script>



